import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import DefaultClass from './DefaultOption';
import NoBorderClass from './NoBorder';
import SolidBorderClass from './SolidBorder';
import OfferBorderClass from './OfferStyleBorder';
import InlineClass from './InlineStyle';
import VerticalClass from './VerticalStyle';
import HorizontalClass from './HorizontalStyle';

const MegaOptionContainer = () => {
  return (
    <Container fluid={true} className='mega-options'>
      <Breadcrumbs parent='Form Controls' title='Mega Options' pageTitle='Mega Options' />
      <Row>
        <DefaultClass />
        <NoBorderClass />
        <SolidBorderClass />
        <OfferBorderClass />
        <InlineClass />
        <VerticalClass />
        <HorizontalClass />
      </Row>
    </Container>
  );
};

export default MegaOptionContainer;
